import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { SxProps } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { memo } from 'react';
import { Trans } from 'react-i18next';
import IIbanUpdatePanelCardItemProps from './IIbanUpdatePanelCardItemProps';

const styles: { [key: string]: SxProps } = {
  operationContent: {
    paddingBottom: '8px !important',
    padding: '8px !important',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  amount: {
    fontSize: '18px',
    flexBasis: '25%',
    textAlign: 'right',
  },

  operationContentBox: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
};

const IbanUpdatePanelCardItem = ({ ibanUpdate, handleOpenModal }: IIbanUpdatePanelCardItemProps) => (
  <Card
    sx={{
      mb: 1,
      border: '1px solid',
      borderColor: Array.isArray(ibanUpdate.errors) && ibanUpdate.errors.length > 0 ? 'warning.main' : 'lightGray',
    }}
  >
    <ButtonBase sx={{ width: '100%' }} onClick={handleOpenModal}>
      <CardContent sx={styles.operationContent}>
        <Box sx={styles.operationContentBox}>
          <Typography variant="body2" fontSize="19px">
            <b>
              <Trans>{ `operation_iban_update_${ ibanUpdate.place }` }</Trans>
            </b>
          </Typography>
          <Typography variant="body2" fontSize="11px">
            <Trans>operation_iban_update</Trans>
          </Typography>
        </Box>

        <Box sx={{ alignSelf: 'flex-end' }}>
          <Typography variant="body2" fontSize="11px">
            { ibanUpdate.validatedAt ? (
              <>
                { format(new Date(ibanUpdate.validatedAt as string), 'dd/MM/yyyy') } •{ ' ' }
                { ibanUpdate.sentAt && format(new Date(ibanUpdate.sentAt as string), 'dd/MM/yyyy') }
              </>
            ) : (
              <>{ ibanUpdate.createdAt ? format(new Date(ibanUpdate.createdAt as string), 'dd/MM/yyyy') : '-' }</>
            ) }
          </Typography>
        </Box>
      </CardContent>
    </ButtonBase>
  </Card>
);

export default memo(IbanUpdatePanelCardItem);
